import { RefreshArrow } from '@berlitz/icons'
import PortalLearningPathUnit from '@classes/LearningPathUnit'
import Progress from '@components/Progress'
import RoleBasedView from '@components/RoleBasedView'
import usePortalFeatures from '@components/RoleBasedView/usePortalFeatures'
import {
  Anchor,
  Link,
  LinkItemFlex,
  ProgressContainer,
  RedoButton,
  StatusText,
} from '@layouts/LearningPath/Chapter/style'
import { STATUS_TEXT_MAPPING } from '@utils/constants'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import ExtraPracticeIcon from './ExtraPracticeIcon'

export interface Props {
  Unit: PortalLearningPathUnit
  setShowConfirmation: (arg0: boolean) => void
  showConfirmation: boolean
  profileType: string
}

const ActivityCard: React.FC<Props> = ({ Unit, setShowConfirmation, showConfirmation, profileType }) => {
  const { state, features } = usePortalFeatures({
    configId: 'c::newLearningExperience',
  })
  return (
    <Link status={Unit.Status}>
      {Unit.getOrderedActivities(profileType)?.map((Activity, index) => (
        <React.Fragment key={`${Activity.Type}-${index}`}>
          {Activity.isTypedActivity(profileType) && (
            <LinkItemFlex>
              <ExtraPracticeIcon status={Unit.LessonStatus!} />
              <div>
                <StatusText>
                  <FormattedMessage id={`Lesson ${STATUS_TEXT_MAPPING.LS[Unit.LessonStatus || '']}`} />
                </StatusText>
                {(() => {
                  const activityUrl = Activity.Url || Unit.getAttachmentUrlByType(Unit.unit?.attachments, 'sg_pdf')
                  if (!activityUrl) return null
                  return (
                    <>
                      <Anchor onClick={() => window.open(activityUrl, '_blank')}>
                        <FormattedMessage id={`${Activity.Name}`} />
                      </Anchor>
                    </>
                  )
                })()}
              </div>
            </LinkItemFlex>
          )}

          {Activity.isOtherActivity(profileType) && (
            <RoleBasedView configId={`c::learningPath::nonFlexCard::link::${Activity.Type}`}>
              <LinkItemFlex>
                <ExtraPracticeIcon status={Unit.UnitStatus} />
                <div>
                  <StatusText>
                    <FormattedMessage id={`${STATUS_TEXT_MAPPING.US[Unit.UnitStatus || '']}`} />
                  </StatusText>
                  <div className="display-inline-block">
                    <div className="display-flex">
                      <Anchor
                        onClick={() => {
                          if (state.allowed) {
                            return features.cr8.redirectToCR8(Unit?.LearningPathId ?? '', Activity.Url)
                          }

                          window.open(Activity.Url, '_self')
                        }}
                      >
                        <FormattedMessage id={`${Activity.Name}`} />
                      </Anchor>
                      {Unit.Completion === 100 && (
                        <RoleBasedView configId="c::learningPath::nonFlexCard::redoButton">
                          <RedoButton onClick={() => setShowConfirmation(!showConfirmation)}>
                            <RefreshArrow color="brand02" size="xs" />
                          </RedoButton>
                        </RoleBasedView>
                      )}
                    </div>
                  </div>
                </div>
                <RoleBasedView configId="c::learningPath::progressbar::onlinePractice">
                  <ProgressContainer>
                    <Progress percent={Unit.Completion} />
                  </ProgressContainer>
                </RoleBasedView>
              </LinkItemFlex>
            </RoleBasedView>
          )}
        </React.Fragment>
      ))}
    </Link>
  )
}

export default ActivityCard
